"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostResponse = exports.isSSGPage = exports.isSSRPage = exports.isAPrivatePage = exports.getHostRouteURL = exports.getPrivateRouteURL = exports.getPrivateRoutePath = exports.PRIVATE_ROUTE_PATH = exports.isUserLandingInANewPage = void 0;
var Url_helper_1 = require("./Url.helper");
var envConfig_1 = require("../envConfig");
var isUserLandingInANewPage = function (req) {
    return !req.url.match(/^\/_next\/data\//);
};
exports.isUserLandingInANewPage = isUserLandingInANewPage;
exports.PRIVATE_ROUTE_PATH = "/area_riservata/";
var getPrivateRoutePath = function (path) {
    return "".concat(exports.PRIVATE_ROUTE_PATH).concat(path);
};
exports.getPrivateRoutePath = getPrivateRoutePath;
var getPrivateRouteURL = function (path) {
    return (0, exports.getHostRouteURL)((0, exports.getPrivateRoutePath)(path));
};
exports.getPrivateRouteURL = getPrivateRouteURL;
var getHostRouteURL = function (path) {
    return "".concat(envConfig_1.COMMON_ENV_CONFIG.HOST_ENDPOINT).concat(path);
};
exports.getHostRouteURL = getHostRouteURL;
var isAPrivatePage = function (page) {
    var regex = new RegExp(exports.PRIVATE_ROUTE_PATH);
    return regex.test(page.url);
};
exports.isAPrivatePage = isAPrivatePage;
var isSSRPage = function (page) { return Url_helper_1.UrlHelper.isSSRPageUrl(page.url); };
exports.isSSRPage = isSSRPage;
var isSSGPage = function (page) { return Url_helper_1.UrlHelper.isSSGPageUrl(page.url); };
exports.isSSGPage = isSSGPage;
var HostResponse = function (data) { return ({
    content: {
        data: data,
    },
}); };
exports.HostResponse = HostResponse;
